import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Questions } from './components/Questions';
import { TarotFrame } from './components/TarotFrame';
import { Proposal } from './components/Proposal';
import { UrgentCTA } from './components/UrgentCTA';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { VideoCall } from './components/VideoCall';
import { ContactFooter } from './components/ContactFooter';
import { TawkToWidget } from './components/TawkToWidget';
export function App() {
  return <div className="min-h-screen w-full bg-ink font-sans text-white" data-id="element-0" data-mp="31b8fzobovt4g">
      <Header data-id="element-1" data-mp="2wk0a329kipw1" />
      <main data-id="element-2" data-mp="2wk9y4kb1ymz3">
        <Hero data-id="element-3" data-mp="2wjqgz5t882m4" />
        <Questions data-id="element-4" data-mp="2wj8cxn0bok3n" />
        <TarotFrame data-id="element-5" data-mp="2wip5j08ate3v" />
        <Proposal data-id="element-6" data-mp="2wi5l9cv6edmo" />
        <UrgentCTA data-id="element-7" data-mp="28u5ysp4wd9dw" />
        <Services data-id="element-8" data-mp="28tmi1bqzgr1g" />
        <Testimonials data-id="element-9" data-mp="28t4jg8gum0qd" />
        <VideoCall data-id="element-10" data-mp="28sb9yzqi8x4j" />
      </main>
      <ContactFooter data-id="element-11" data-mp="23vkzqt1dsvr1" />
      <TawkToWidget data-id="element-12" data-mp="23u9u0nodldxa" />
    </div>;
}